import { kMissingPic } from "../constants";
import { QPicDesc } from "../CoreApp/QPicDesc";
import { IsURL } from "./IsURL";
import { GetExtension } from "./GetExtension";

export function GetPicSource(dataObj, fieldDef, dataValue) {
  var pFile = kMissingPic;
  var pDir = "Photos";
  var refURL = false;

  var picDesc = new QPicDesc();

  var s = dataObj && fieldDef ? dataObj.GetFieldValue(fieldDef) : dataValue;
  if (s) {
    s = s.toString();
    var refURL = IsURL(s);
    if (refURL) {
      var isBreathe = s.indexOf("breathehr") > -1 && s.indexOf("Signature") > -1;
      var isGravatar = s.indexOf("gravatar") > -1 && s.indexOf("?d=") > -1;
      if (isBreathe || isGravatar) {
        if (s.indexOf("https") !== 0 || s.indexOf("http") !== 0) s = "https:" + s;
        s = decodeURIComponent(s);
      }
      pFile = s;
      pDir = "Temp";
    } else {
      var s1 = s.split(":");
      var np = s1.length;
      if (np == 1) pFile = s1[0];
      else {
        pDir = s1[0];
        pFile = s1[1];
        for (var i = 2; i < np; i++) pFile += ":" + s1[i];
      }

      if (pFile == "") pFile = kMissingPic;

      var ext = GetExtension(pFile);
      if (ext == "") pFile += ".jpg";
    }
  }

  picDesc.fDirectory = pDir;
  picDesc.fFileName = pFile;
  picDesc.fIsURL = refURL;

  return picDesc;
}
